import { memberApiV2 } from '@lib/api';
import { AsyncSelect } from '../../ui/inputs/select';
import React from 'react';
import { useIntl } from 'react-intl';
import { ActionMeta, OptionTypeBase, ValueType } from 'react-select';

interface InsuranceProvidersSelectProps {
  value?: ValueType<OptionTypeBase, true>;
  onChange?: (value: ValueType<OptionTypeBase, true>, action: ActionMeta<OptionTypeBase>) => void;
}

const InsuranceProvidersSelect: React.FunctionComponent<InsuranceProvidersSelectProps> = (
  props,
) => {
  const { formatMessage, locale } = useIntl();

  const insuranceProvidersOpts = React.useCallback(async () => {
    const institutions = (await memberApiV2.getInsuranceProviders(locale.toUpperCase())).data;
    return institutions.data.map((e: any) => ({
      value: e.id,
      label: e.name,
    }));
  }, [locale]);

  return (
    <AsyncSelect
      loadOptions={insuranceProvidersOpts}
      isMulti
      cacheOptions
      defaultOptions
      placeholder={formatMessage({ id: 'rs_placeholder' })}
      {...props}
    />
  );
};

export default InsuranceProvidersSelect;
